/**
 * Video Play Button Component
 * Handles custom play button functionality for video elements
 */
class VideoPlayButton {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Find all video containers with play buttons
    const videoContainers = document.querySelectorAll('.video-container');
    
    videoContainers.forEach(container => {
      const video = container.querySelector('video');
      const playButton = container.querySelector('.video-play-button');
      
      if (video && playButton) {
        this.setupVideo(container, video, playButton);
      }
    });
  }

  setupVideo(container, video, playButton) {
    // Hide video controls initially
    video.controls = false;
    
    // Track if video has been played at least once
    let hasPlayed = false;
    
    // Play button click handler
    playButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.playVideo(video, playButton);
    });

    // Video click handler (click on video to play)
    video.addEventListener('click', (e) => {
      e.preventDefault();
      this.playVideo(video, playButton);
    });

    // Hide play button when video starts playing
    video.addEventListener('play', () => {
      hasPlayed = true;
      this.hidePlayButton(playButton);
    });

    // Show play button when video ends (only if it hasn't been played before)
    video.addEventListener('ended', () => {
      if (!hasPlayed) {
        this.showPlayButton(playButton);
      }
    });

    // Show play button on load
    video.addEventListener('loadeddata', () => {
      this.showPlayButton(playButton);
    });
  }

  playVideo(video, playButton) {
    // Show video controls when playing
    video.controls = true;
    
    // Play the video
    video.play().then(() => {
      this.hidePlayButton(playButton);
    }).catch(error => {
      console.error('Error playing video:', error);
      // If autoplay fails, show play button again
      this.showPlayButton(playButton);
    });
  }

  hidePlayButton(playButton) {
    playButton.classList.add('hidden');
  }

  showPlayButton(playButton) {
    playButton.classList.remove('hidden');
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new VideoPlayButton();
});

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
  module.exports = VideoPlayButton;
}
